"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMonitorData = exports.createEventMonitorData = exports.Monitor = exports.MonitorComponent = exports.directive = void 0;
var utils_1 = require("./utils");
var package_json_1 = require("./package.json");
var install_1 = require("./install");
var Monitor = (function () {
    function Monitor(options) {
        this._apps = [];
        this.setReportRequest(options.report);
    }
    Monitor.prototype.init = function (app) {
        this._apps.push(app);
        if (this._app)
            return;
        this._app = app;
        this.routeGuard();
    };
    Monitor.prototype.setReportRequest = function (report) {
        this._report = report;
    };
    Monitor.prototype.routeGuard = function () {
        var _this = this;
        var _a;
        var router = (_a = this._app.$options) === null || _a === void 0 ? void 0 : _a.router;
        if (!router)
            return;
        router.beforeEach(function (to, from, next) {
            var _a;
            (_a = _this._report) === null || _a === void 0 ? void 0 : _a.call(_this, {
                operation: '页面跳转',
                module: '',
                remark: '页面跳转',
                params: JSON.stringify({ to: (0, utils_1.handleRouteConfig)(to), from: (0, utils_1.handleRouteConfig)(from) }),
            });
            next();
        });
    };
    Monitor.prototype._request = function (data, withPageInfo) {
        var _a = data.params, params = _a === void 0 ? {} : _a, rest = __rest(data, ["params"]);
        if (withPageInfo) {
            var _b = this._app.$options.router.app._route, fullPath = _b.fullPath, path = _b.path, query = _b.query;
            Object.assign(params, { fullPath: fullPath, path: path, query: query });
        }
        return this._report(__assign(__assign({}, rest), { params: JSON.stringify(params) }));
    };
    Monitor.prototype.request = function (data) {
        return this._request(data, false);
    };
    Monitor.prototype.requestWithPage = function (data) {
        return this._request(data, true);
    };
    return Monitor;
}());
exports.Monitor = Monitor;
exports.default = Monitor;
Monitor.install = install_1.install;
Monitor.version = package_json_1.version;
if (typeof window !== undefined && window.Vue) {
    window.Vue.use(Monitor);
}
var directive_1 = require("./directive");
Object.defineProperty(exports, "directive", { enumerable: true, get: function () { return directive_1.directive; } });
var component_1 = require("./component");
Object.defineProperty(exports, "MonitorComponent", { enumerable: true, get: function () { return component_1.MonitorComponent; } });
var createEventMonitorData = function (data, event) {
    if (event === void 0) { event = 'click'; }
    var events = [].concat(event);
    return events.reduce(function (map, key) {
        map[key] = data;
        return map;
    }, {});
};
exports.createEventMonitorData = createEventMonitorData;
var defineMonitorData = function (data) { return data; };
exports.defineMonitorData = defineMonitorData;
